const getParam = (url, sname) => {
    var params = url.substring(url.indexOf("?") + 1);
    var sval = "";
    var temp = [];
    // console.log('url', url);
    // console.log('params', params);
    params = params.split("&");
    for (var i = 0; i < params.length; i++) {
        temp = params[i].split("=");
        // console.log('temp', temp);
        if ([temp[0]] == sname) { sval = temp[1]; }
    }
    // console.log("sval", sval);
    return sval;
};
export default getParam;